import { proExperienceSectionQueryOptions } from "api/queries/pros";
import type { WarmableQuery } from "routing/warmQueries";

type QueriesInput = { id: number };

export const experienceQuery = ({ id }: QueriesInput) => proExperienceSectionQueryOptions(id);

export const queries = (input: QueriesInput): Array<WarmableQuery> => [experienceQuery(input)];
